import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import styles from './Month.module.scss'
import { getCalendarDays, getStartDate, getCalendarEndDate } from '../../../../utils'
import { useEventsStore } from 'store/useEventsStore'
import DaysOfWeekHeader from '../DaysOfWeekHeader/DaysOfWeekHeader'
import Day from '../Day/Day'
import { ConditionalWrapper } from '~elements'
import type { ArtistProps } from '../../../../types'
import type { FormattedEvent } from '../../../../types/Event'

type Variant = 'desktop' | 'tablet'

type MonthProps = {
  month: Dayjs
  variant: Variant
  handleDateSelection: (events: FormattedEvent[], artist: ArtistProps) => void
}

const Month = ({ month, variant, handleDateSelection }: MonthProps) => {
  const { artists, eventsByDate, filteredEventName } = useEventsStore()
  const today = dayjs()
  const isTablet = variant === 'tablet'
  const isDesktop = variant === 'desktop'

  const startDate = getStartDate(month, variant, today)
  const endDate = month.endOf('month')
  const calendarStartDate = isDesktop ? startDate.startOf('week') : startDate
  //Calculate calendar end date only for desktop variant to fill the last week
  const calendarEndDate = isDesktop ? getCalendarEndDate(endDate) : endDate

  const isLastWeekOfMonth = today.isSame(endDate, 'week')
  const weeks = getCalendarDays(startDate, calendarStartDate, calendarEndDate, eventsByDate, filteredEventName)

  return (
    <div className={styles['calendar__month']}>
      {isDesktop && <DaysOfWeekHeader />}
      {weeks.map((week, weekIdx) => (
        <ConditionalWrapper
          key={weekIdx}
          condition={isDesktop}
          wrapper={children => (
            <div key={`week_${weekIdx}`} className={styles['calendar__week']}>
              {children}
            </div>
          )}
        >
          {week.map(dayInfo => (
            <Day
              key={dayInfo.date.toISOString()}
              dayInfo={dayInfo}
              artists={artists}
              isTablet={isTablet}
              isDesktop={isDesktop}
              isLastWeekOfMonth={isLastWeekOfMonth}
              handleDateSelection={handleDateSelection}
            />
          ))}
        </ConditionalWrapper>
      ))}
    </div>
  )
}

export default Month
